import React from 'react';
import { Utensils, Heart, Apple, Leaf } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/_modules.scss';

const healthyEatingImage = require('../assets/Nutritional Resources.png');

const modules = [
  {
    id: 'm1',
    title: 'Introduction to Healthy Eating',
    icon: <Apple size={24} />,
    image: healthyEatingImage.default || healthyEatingImage,
    description: 'Learn the fundamentals of healthy eating, including the importance of variety, moderation, and nutrient-rich foods.'
  },
  {
    id: 'm2',
    title: 'Building Balanced Meals',
    icon: <Utensils size={24} />,
    image: healthyEatingImage.default || healthyEatingImage,
    description: 'Discover how to create meals that balance macronutrients and include plenty of fruits, vegetables, whole grains, and lean proteins.'
  },
  {
    id: 'm3',
    title: 'Mindful Eating Practices',
    icon: <Heart size={24} />,
    image: healthyEatingImage.default || healthyEatingImage,
    description: 'Explore techniques for mindful eating to improve your relationship with food and support healthy habits.'
  },
  {
    id: 'm4',
    title: 'Nutrition for Long-Term Wellness',
    icon: <Leaf size={24} />,
    image: healthyEatingImage.default || healthyEatingImage,
    description: 'Understand how to maintain healthy eating habits for lifelong wellness and disease prevention.'
  }
];

const HealthyEatingHabitsPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  return (
    <div className={`resources-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="module-resources_container">
        {/* Header Section */}
        <div className="module-resources_header">
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Healthy Eating Habits</h2>
            </div>
          </div>
        </div>
        {/* Modules Grid */}
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            {modules.map((module) => (
              <div key={module.id} className="module-resources_module-card" onClick={() => {
                if (module.id === 'm1') navigate('/panel/wellness-loop/healthy-eating-module-1');
                if (module.id === 'm2') navigate('/panel/wellness-loop/healthy-eating-module-2');
                if (module.id === 'm3') navigate('/panel/wellness-loop/healthy-eating-module-3');
                if (module.id === 'm4') navigate('/panel/wellness-loop/healthy-eating-module-4');
              }} role="button" tabIndex={0} onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  if (module.id === 'm1') navigate('/panel/wellness-loop/healthy-eating-module-1');
                  if (module.id === 'm2') navigate('/panel/wellness-loop/healthy-eating-module-2');
                  if (module.id === 'm3') navigate('/panel/wellness-loop/healthy-eating-module-3');
                  if (module.id === 'm4') navigate('/panel/wellness-loop/healthy-eating-module-4');
                }
              }}>
                <div className="module-resources_module-image">
                  <img src={module.image} alt={module.title} />
                </div>
                <div className="module-resources_module-content">
                  <h3 className="module-resources_module-title">{module.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthyEatingHabitsPage;

